import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import uniqid from 'uniqid'

import './Toggle.scss'

export const Toggle = ({
  checked,
  className,
  disabled,
  id,
  name,
  onChange,
  value,
  variant,
  tooltip,
  'data-mu-test': dataAttributeTest
}) => {
  const { current: inputName } = useRef(
    name ? `input-${name}` : uniqid('input-')
  )
  const inputId = id || `${inputName}-${value}`

  const handleChange = e => {
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <span
      className={classnames(
        'e-toggle',
        {
          'e-toggle--disabled': disabled,
          'e-toggle--sm': variant === 'sm',
          'e-toggle--with-tooltip': tooltip
        },
        className
      )}
      data-mu-test={classnames('toggle', dataAttributeTest)}
      data-tip={tooltip}
    >
      <label htmlFor={inputId}>
        <input
          type='checkbox'
          className={'e-toggle__input'}
          name={name}
          id={inputId}
          value={value}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className='e-toggle__track' />
      </label>
    </span>
  )
}

Toggle.defaultProps = {
  labelClassName: 'label-simple',
  disabled: false
}

Toggle.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  variant: PropTypes.oneOf(['sm']),
  tooltip: PropTypes.any,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
